(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[603],{

/***/ 7646:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(8202);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9081:
/***/ (function(module) {

"use strict";
// The gallery API rate-limits (120/min) per connection, and Node >= 19 reuses
// sockets by default, so a reused socket hits 429 under normal traffic. Open a
// new connection per request, as Node 18 did. Server-only: the typeof check lets
// Next drop http/https from the browser bundle (the client uses XHR anyway).

module.exports =  false ? 0 : {};


/***/ }),

/***/ 1769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useExhibitionsActions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _services_utils_removeEmptyFromObject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3408);
/* harmony import */ var _services_utils_sorts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7599);
/* harmony import */ var _useInfinitePagination__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6578);
/* harmony import */ var _services_nodeApiService__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9885);





const useExhibitionsActions = function(_exhibitions) {
    let searchTerm = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, withGalleryFeatured = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const [exhibitions, setExhibitions] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_exhibitions);
    const _sorts = _services_utils_sorts__WEBPACK_IMPORTED_MODULE_1__/* .sorts.exhibitions */ .L.exhibitions;
    const [sort, setSort] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("createddesc");
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [search, setSearch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(searchTerm);
    const { loadingMore , setPage , setShouldCall  } = (0,_useInfinitePagination__WEBPACK_IMPORTED_MODULE_2__/* .useInfinitePagination */ .J)((page)=>callApi(page), (response)=>setExhibitions({
            ...exhibitions,
            data: [
                ...exhibitions.data,
                ...response.data
            ]
        }));
    const callApi = (page)=>{
        const body = (0,_services_utils_removeEmptyFromObject__WEBPACK_IMPORTED_MODULE_4__/* .removeEmptyFromObject */ .h)({
            page,
            order: sort,
            search,
            withGalleryFeatured: withGalleryFeatured ? true : undefined
        });
        if (Object.keys(body).length !== 0) {
            return _services_nodeApiService__WEBPACK_IMPORTED_MODULE_3__/* ["default"].exhibitions */ .Z.exhibitions(body);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (search !== null || sort !== null) {
            setPage(1);
            setLoading(true);
            setShouldCall(true);
            callApi().then((response)=>{
                setExhibitions(response.data);
                setLoading(false);
            });
        }
    }, [
        search,
        sort
    ]);
    return {
        exhibitions,
        setSearch,
        loading,
        sort,
        setSort,
        sorts: _sorts,
        loadingMore
    };
};


/***/ }),

/***/ 2491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useGalleriesAction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9885);
/* harmony import */ var _services_utils_removeEmptyFromObject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3408);
/* harmony import */ var _services_utils_sorts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7599);
/* harmony import */ var _useInfinitePagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6578);





const useGalleriesAction = function(galleriesData) {
    let searchTerm = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    const [galleries, setGalleries] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(galleriesData);
    const _sorts = _services_utils_sorts__WEBPACK_IMPORTED_MODULE_2__/* .sorts.galleries */ .L.galleries;
    const [sort, setSort] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [search, setSearch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(searchTerm);
    const { loadingMore , setPage , setShouldCall  } = (0,_useInfinitePagination__WEBPACK_IMPORTED_MODULE_3__/* .useInfinitePagination */ .J)((page)=>callApi(page), (response)=>setGalleries({
            ...galleries,
            data: [
                ...galleries.data,
                ...response.data
            ]
        }));
    const callApi = (page)=>{
        const body = (0,_services_utils_removeEmptyFromObject__WEBPACK_IMPORTED_MODULE_4__/* .removeEmptyFromObject */ .h)({
            search,
            page,
            order: sort
        });
        if (Object.keys(body).length !== 0) {
            return _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].galleries */ .Z.galleries(body);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (search !== null || sort !== null) {
            setPage(1);
            setLoading(true);
            setShouldCall(true);
            callApi().then((response)=>{
                setGalleries(response.data);
                setLoading(false);
            });
        }
    }, [
        search,
        sort
    ]);
    return {
        galleries,
        setSearch,
        loading,
        loadingMore,
        sort,
        setSort,
        sorts: _sorts
    };
};


/***/ }),

/***/ 3280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3992);
/* harmony import */ var _Layout_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6627);
/* harmony import */ var _CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8351);
/* harmony import */ var _CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5__);







const CircleImages = (param)=>{
    let { title , subtitle , image , href , to  } = param;
    const initials = title.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "").toUpperCase().substring(0, 3);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        as: to,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["circle-image-container"]), "margin m0a"),
        children: [
            image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_Image__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .E, {
                src: (0,_services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_6__/* .imageResizer */ .J)(image, 200, 200),
                width: "150px",
                height: "150px",
                labelHeight: "150px",
                labelWidth: "150px",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default().circles), "mb-4", "mx-auto"),
                alt: title
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["gallery-logo"]), "mb-4", "mx-auto"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["gallery-inicials"]),
                    children: initials
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: "text-black text-center mb-2 font-secondary fw-700 fs-16px",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-center color-gray-super-light font-primary fs-13px font-primary",
                children: subtitle
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CircleImages);


/***/ }),

/***/ 3544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ExhibitionsBig_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6390);
/* harmony import */ var _ExhibitionsBig_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ExhibitionsBig_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1555);
/* harmony import */ var _Layout_ButtonCta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8966);






const ExhibitionCard = (props)=>{
    const { id , description , image , date , name , href , to , cta , author , titleHeader  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ExhibitionsBig_module_css__WEBPACK_IMPORTED_MODULE_4___default().exhibitions),
        style: {
            backgroundImage: "url(".concat(image, ")")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_ExhibitionsBig_module_css__WEBPACK_IMPORTED_MODULE_4___default().exhibitionInfo),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: "h-100",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: "d-flex justify-content-center justify-content-lg-start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_ExhibitionsBig_module_css__WEBPACK_IMPORTED_MODULE_4___default().bottom),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "color-white fs-12px fw-300 mb-0",
                                    children: titleHeader
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "color-white fs-36px fw-300 mb-0",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "fs-14px color-white font-primary",
                                    children: author
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        xs: 12,
                        lg: 4,
                        className: "d-flex justify-content-center justify-content-lg-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ExhibitionsBig_module_css__WEBPACK_IMPORTED_MODULE_4___default().bottom),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: href,
                                as: to,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_ButtonCta__WEBPACK_IMPORTED_MODULE_3__/* .ButtonCta */ .N, {
                                    title: cta
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ExhibitionCard);


/***/ }),

/***/ 8966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ButtonCta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1772);
/* harmony import */ var _ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const ButtonCta = (param)=>/*#__PURE__*/ {
    let { className , onClick , title , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        type: "button",
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, "btn btn-outline-secondary fs-12px tt-u", (_ButtonCta_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button)),
        children: title || children
    });
};


/***/ }),

/***/ 8202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./services/utils/linksBuilder.js
var linksBuilder = __webpack_require__(3372);
// EXTERNAL MODULE: ./services/utils/isEmptyObject.js
var isEmptyObject = __webpack_require__(9657);
// EXTERNAL MODULE: ./services/utils/sorts.js
var sorts = __webpack_require__(7599);
// EXTERNAL MODULE: ./services/WindowService/index.js + 1 modules
var WindowService = __webpack_require__(2480);
// EXTERNAL MODULE: ./features/pages/ArtworksPage/utils/buildParams.js
var buildParams = __webpack_require__(6836);
// EXTERNAL MODULE: ./services/nodeApiService.js + 1 modules
var nodeApiService = __webpack_require__(9885);
;// CONCATENATED MODULE: ./features/pages/SearchPage/callArtworksResultsApi.js

const callArtworksResultsApi = (params)=>{
    const callback = !params.page ? nodeApiService/* default.search */.Z.search : nodeApiService/* default.artworks */.Z.artworks;
    return callback(params);
};

// EXTERNAL MODULE: ./features/actions/useInfinitePagination.js
var useInfinitePagination = __webpack_require__(6578);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./config/galleryApiAgents.js
var galleryApiAgents = __webpack_require__(9081);
;// CONCATENATED MODULE: ./config/axiosGalleryClient.js
/* provided dependency */ var process = __webpack_require__(3454);


const client = axios_default().create({
    baseURL: "https://galleries-api-production.herokuapp.com/",
    httpAgent: galleryApiAgents.httpAgent,
    httpsAgent: galleryApiAgents.httpsAgent,
    headers: {
        "API-KEY": "".concat(process.env.API_KEY)
    }
});
client.interceptors.response.use((response)=>{
    return response;
}, function(error) {
    return Promise.reject(error);
});
const axiosGalleryClient = client;

;// CONCATENATED MODULE: ./services/galleryApiService.js

const galleryApiService = ()=>({
        home: ()=>axiosGalleryClient.get("home"),
        featured: ()=>axiosGalleryClient.get("galleries/featured"),
        galleries: ()=>axiosGalleryClient.get("galleries"),
        gallery: (id)=>axiosGalleryClient.get("galleries/".concat(id)),
        galleryByDomain: (domain)=>axiosGalleryClient.get("galleries/domain/".concat(domain)),
        galleryArtworks: (id, params)=>axiosGalleryClient.get("galleries/".concat(id, "/artworks"), {
                params
            }),
        galleryArtworksByCollection: function(id, collection_slug) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return axiosGalleryClient.get("galleries/".concat(id, "/collections/").concat(encodeURIComponent(collection_slug)), {
                params
            });
        },
        artworks: (params)=>{
            return axiosGalleryClient.get("artworks", {
                params
            });
        },
        search: (params)=>{
            return axiosGalleryClient.get("search", {
                params
            });
        },
        searchGalleries: (params)=>{
            return axiosGalleryClient.get("galleries", {
                params
            });
        },
        artwork: (id)=>axiosGalleryClient.get("artworks/".concat(id)),
        relatedArtworks: (id)=>axiosGalleryClient.get("artworks/".concat(id, "/related")),
        spaces: (params)=>axiosGalleryClient.get("spaces", {
                params
            }),
        space: (id)=>axiosGalleryClient.get("spaces/".concat(id)),
        contact: (body)=>{
            return axiosGalleryClient.post("contact", body);
        },
        dataCapture: (galleryId, body)=>{
            return axiosGalleryClient.post("galleries/".concat(galleryId, "/datacapture"), body);
        },
        contactGallery: (galleryId, body)=>{
            return axiosGalleryClient.post("galleries/".concat(galleryId, "/contact"), body);
        },
        inquire: (artworkId, body)=>{
            return axiosGalleryClient.post("artworks/".concat(artworkId, "/inquire"), body);
        },
        purchase: (artworkId, body)=>{
            return axiosGalleryClient.post("artworks/".concat(artworkId, "/purchase"), body);
        },
        exhibitions: (params)=>axiosGalleryClient.get("exhibitions", {
                params
            }),
        exhibition: (id)=>axiosGalleryClient.get("exhibitions/".concat(id)),
        artworksfilters: ()=>axiosGalleryClient.get("artworks/filters")
    });
/* harmony default export */ var services_galleryApiService = (galleryApiService());

;// CONCATENATED MODULE: ./features/pages/SearchPage/useArtworksResultsAction.js








const totalFilters = (search)=>{
    return Object.keys(search).map((key)=>search[key]).filter((val)=>{
        return Array.isArray(val) ? val.length > 0 : !!val;
    }).length;
};
const useArtworksResultsAction = (param)=>{
    let { catalogData , setCatalogData  } = param;
    const [loading, setLoading] = (0,react.useState)(false);
    const [firstRender, setFirstRender] = (0,react.useState)(true);
    const [showFilters, setShowFilters] = (0,react.useState)(false);
    const _sorts = sorts/* sorts.artworks */.L.artworks;
    const [sort, setSort] = (0,react.useState)(null);
    const [search, setSearch] = (0,react.useState)({
        colors: [],
        collections: [],
        sizes: [],
        type: [],
        orientations: [],
        medium: [],
        material: [],
        minHeight: "",
        maxHeight: "",
        minWidth: "",
        maxWidth: ""
    });
    const [collapses, setCollapses] = (0,react.useState)({
        collections: false,
        sizes: false,
        type: false,
        orientations: false,
        medium: false,
        material: false,
        dimensions: false,
        colors: false
    });
    const { setPage , setShouldCall  } = (0,useInfinitePagination/* useInfinitePagination */.J)((page)=>{
        let params = (0,buildParams/* buildParams */.U)(search);
        return callArtworksResultsApi({
            ...params,
            page
        });
    }, (response)=>{
        setCatalogData({
            ...catalogData,
            data: [
                ...catalogData.data,
                ...response.data
            ]
        });
    });
    (0,react.useEffect)(()=>{
        const params = (0,buildParams/* buildParams */.U)(search, sort);
        if (!(0,isEmptyObject/* isEmptyObject */.Q)(params)) {
            setLoading(true);
            setPage(1);
            setShouldCall(true);
            callArtworksResultsApi(params).then((response)=>{
                setCatalogData(response.data.artworks);
                setLoading(false);
            });
        } else if (!firstRender) {
            callCleanApi();
        }
    }, [
        search,
        sort
    ]);
    (0,react.useEffect)(()=>{
        setFirstRender(false);
    }, []);
    const clearFilters = ()=>{
        setSearch({
            colors: [],
            collections: [],
            sizes: [],
            type: [],
            orientations: [],
            medium: [],
            material: [],
            minHeight: "",
            maxHeight: "",
            minWidth: "",
            maxWidth: ""
        });
        callCleanApi();
    };
    const callCleanApi = ()=>{
        setPage(1);
        const params = (0,buildParams/* buildParams */.U)({
            colors: [],
            collections: [],
            sizes: [],
            type: [],
            orientations: [],
            medium: [],
            material: [],
            minHeight: "",
            maxHeight: "",
            minWidth: "",
            maxWidth: ""
        }, sort);
        setShouldCall(true);
        WindowService/* default.animatedScrollTop */.Z.animatedScrollTop();
        setLoading(true);
        callArtworksResultsApi({
            search: params.search
        }).then((response)=>{
            console.log(response);
            setCatalogData(response.data.artworks);
            setLoading(false);
        });
    };
    const onClickString = (key, value)=>{
        search[key] = value;
        setSearch({
            ...search
        });
    };
    const onClickArray = (key, value)=>{
        const index = search[key].indexOf(value);
        if (index === -1) {
            search[key].push(value);
        } else {
            search[key].splice(index, 1);
        }
        setSearch({
            ...search
        });
    };
    const onClickItem = (key, value)=>{
        if ([
            "minHeight",
            "maxHeight",
            "minWidth",
            "maxWidth"
        ].includes(key)) {
            return onClickString(key, value);
        }
        return onClickArray(key, value);
    };
    const toggleExpand = (key)=>{
        const _collapses = collapses;
        _collapses[key] = !_collapses[key];
        setCollapses({
            ..._collapses
        });
    };
    return {
        loading,
        setLoading,
        search,
        setSearch,
        collapses,
        setCollapses,
        clearFilters,
        onClickItem,
        toggleExpand,
        totalFilters: totalFilters(search),
        showFilters,
        setShowFilters,
        sort,
        setSort,
        sorts: _sorts
    };
};

// EXTERNAL MODULE: ./features/components/Layout/Container/index.js
var Container = __webpack_require__(1286);
// EXTERNAL MODULE: ./features/components/Layout/HeadingTitle/index.js
var HeadingTitle = __webpack_require__(8434);
// EXTERNAL MODULE: ./features/components/Layout/HelmetTitle/index.js
var HelmetTitle = __webpack_require__(6470);
// EXTERNAL MODULE: ./features/components/Layout/MobileMenu/index.js
var MobileMenu = __webpack_require__(8127);
// EXTERNAL MODULE: ./features/components/Layout/SearchSortHeader/index.js + 3 modules
var SearchSortHeader = __webpack_require__(8984);
// EXTERNAL MODULE: ./features/components/Layout/Wrapper/index.js
var Wrapper = __webpack_require__(1350);
// EXTERNAL MODULE: ./features/components/LeftSide/index.js + 2 modules
var LeftSide = __webpack_require__(6722);
// EXTERNAL MODULE: ./features/components/Layout/Loader/index.js
var Loader = __webpack_require__(9542);
// EXTERNAL MODULE: ./features/components/Masonry/index.js
var Masonry = __webpack_require__(3827);
// EXTERNAL MODULE: ./features/pages/ArtworksPage/ApplyButton.js
var ApplyButton = __webpack_require__(2790);
// EXTERNAL MODULE: ./features/pages/ArtworksPage/FilterButton.js
var FilterButton = __webpack_require__(5449);
// EXTERNAL MODULE: ./features/pages/ArtworksPage/ArtworksPage.module.scss
var ArtworksPage_module = __webpack_require__(2129);
var ArtworksPage_module_default = /*#__PURE__*/__webpack_require__.n(ArtworksPage_module);
// EXTERNAL MODULE: ./features/providers/AppProvider.js
var AppProvider = __webpack_require__(2674);
// EXTERNAL MODULE: ./services/utils/getArtworkSize.js
var getArtworkSize = __webpack_require__(731);
// EXTERNAL MODULE: ./services/utils/getArtworkTitle.js
var getArtworkTitle = __webpack_require__(194);
// EXTERNAL MODULE: ./services/utils/getArtworkSubtitle.js
var getArtworkSubtitle = __webpack_require__(9296);
;// CONCATENATED MODULE: ./features/pages/SearchPage/ArtworksResults.js






















const ArtworksResults = (param)=>{
    let { catalog , onFilter , filters  } = param;
    const { profile  } = (0,AppProvider/* useAppContext */.b)();
    const [catalogData, setCatalogData] = (0,react.useState)(catalog);
    const { loading , search , collapses , clearFilters , onClickItem , toggleExpand , totalFilters , showFilters , setShowFilters , sort , setSort , sorts  } = useArtworksResultsAction({
        catalogData,
        setCatalogData
    });
    const LoadedElements = ()=>{
        if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {});
        const items = catalogData.data.map((item)=>{
            var _item_gallery, _item_gallery1;
            return {
                to: linksBuilder/* linksBuilder.artworks */.m.artworks((_item_gallery = item.gallery) === null || _item_gallery === void 0 ? void 0 : _item_gallery.domain, item.id, item.title),
                href: "/galleries/[id]/artworks/[artwork]",
                title: (0,getArtworkTitle/* getArtworkTitle */.H)(item.title),
                image: item.image,
                subtitle: (0,getArtworkSubtitle/* getArtworkSubtitle */.z)(item.artistname, (_item_gallery1 = item.gallery) === null || _item_gallery1 === void 0 ? void 0 : _item_gallery1.name),
                subSubTitle: (0,getArtworkSize/* getArtworkSize */.Y)(item.width, item.height),
                lastLine: item.gallery.name,
                textAlign: "left"
            };
        });
        onFilter(catalogData.total);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Masonry/* Masonry */.R, {
            id: "artworks",
            items: items
        });
    };
    const Filters = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSide/* default */.Z, {
            search: search,
            collapses: collapses,
            clearFilters: clearFilters,
            onClickItem: onClickItem,
            toggleExpand: toggleExpand,
            totalFilters: totalFilters,
            filters: filters
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: "py-2",
                children: [
                    !profile.embedded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: 12,
                        sm: 12,
                        md: 2,
                        className: "d-none d-md-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                        xs: 12,
                        sm: 12,
                        md: !profile.embedded ? 10 : 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSortHeader/* SearchSortHeader */.y, {
                                hideSearch: true,
                                title: "",
                                sort: sort,
                                setSort: setSort,
                                sorts: sorts,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* FilterButton */.L, {
                                    onClick: ()=>setShowFilters(true)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadedElements, {})
                        ]
                    })
                ]
            }),
            showFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu/* default */.Z, {
                className: (ArtworksPage_module_default())["mobile-menu-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((ArtworksPage_module_default())["filter-mobile"], "position-relative"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplyButton/* ApplyButton */.V, {
                            onClick: ()=>setShowFilters(false)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var SearchPage_ArtworksResults = (ArtworksResults);

// EXTERNAL MODULE: ./features/actions/useGalleriesAction.js
var useGalleriesAction = __webpack_require__(2491);
// EXTERNAL MODULE: ./features/components/CirclesImages/index.js
var CirclesImages = __webpack_require__(3280);
;// CONCATENATED MODULE: ./features/pages/SearchPage/GalleriesResults.js









const GalleriesResults = (param)=>{
    let { galleries: galleriesData , searchTerm  } = param;
    const { galleries , loading , loadingMore  } = (0,useGalleriesAction/* useGalleriesAction */.E)(galleriesData, searchTerm);
    if (!galleries) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {}),
                !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: galleries.data.map((gallery)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 2,
                            lg: 3,
                            md: 4,
                            sm: 6,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CirclesImages/* default */.Z, {
                                title: gallery.name,
                                subtitle: gallery.address,
                                image: gallery.thumbnail,
                                to: linksBuilder/* linksBuilder.galleries */.m.galleries(gallery.domain),
                                href: "/galleries/[id]"
                            })
                        }, "galleries-".concat(gallery.id));
                    })
                }),
                loadingMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
            ]
        })
    });
};
/* harmony default export */ var SearchPage_GalleriesResults = (GalleriesResults);

// EXTERNAL MODULE: ./features/actions/useExhibitionsActions.js
var useExhibitionsActions = __webpack_require__(1769);
// EXTERNAL MODULE: ./features/components/ExhibitionCardBigButton/index.js
var ExhibitionCardBigButton = __webpack_require__(3544);
;// CONCATENATED MODULE: ./features/pages/SearchPage/ExhibitionsResults.js



// import ExhibitionCard from "../../components/ExhibitionCard"





const ExhibitionsResults = (param)=>{
    let { exhibitions , searchTerm  } = param;
    const { exhibitions: paginatedExhibitions , loading , loadingMore  } = (0,useExhibitionsActions/* useExhibitionsActions */.n)(exhibitions, searchTerm, true);
    const Elements = ()=>{
        if (loading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: paginatedExhibitions.data.map((param)=>/*#__PURE__*/ {
                let { id , description , image , thumbnail , date , title , author  } = param;
                return (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    xs: 12,
                    md: 6,
                    lg: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExhibitionCardBigButton/* default */.Z, {
                        id: id,
                        image: thumbnail !== null && thumbnail !== void 0 ? thumbnail : image,
                        name: title,
                        author: author,
                        date: date,
                        to: "/exhibitions/".concat(id),
                        href: "/exhibitions/[id]",
                        cta: "Visit"
                    })
                }, id);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements, {}),
            loadingMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
        ]
    });
};
/* harmony default export */ var SearchPage_ExhibitionsResults = (ExhibitionsResults);

// EXTERNAL MODULE: ./features/pages/ArtworksPage/index.js + 3 modules
var ArtworksPage = __webpack_require__(4461);
// EXTERNAL MODULE: ./features/pages/SearchPage/searchpage.module.css
var searchpage_module = __webpack_require__(4038);
var searchpage_module_default = /*#__PURE__*/__webpack_require__.n(searchpage_module);
;// CONCATENATED MODULE: ./features/pages/SearchPage/index.js











const Search = (param)=>{
    let { results , searchTerm , filters  } = param;
    const [showartworks, setShowartworks] = (0,react.useState)(results.artworks.total > 0);
    const [showgalleries, setShowgalleries] = (0,react.useState)(results.artworks.total == 0 && results.galleries.total > 0);
    const [showexhibitions, setShowexhibitions] = (0,react.useState)(results.artworks.total == 0 && results.galleries.total == 0 && results.exhibitions.total > 0);
    const [totalArtworks, setTotalArtworks] = (0,react.useState)(results.artworks.total);
    const noResults = results.artworks.total == 0 && results.galleries.total == 0 && results.exhibitions.total == 0;
    console.log(searchTerm.search);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelmetTitle/* HelmetTitle */.i, {
                    title: "Search"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-light py-3 ".concat((searchpage_module_default()).searchBar),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((searchpage_module_default()).searchHeader, " d-flex justify-content-between justify-content-md-start  fs-13px"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: (searchpage_module_default()).searchResults,
                                    children: [
                                        "Search results for ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: searchTerm
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "".concat(showartworks ? classnames_default()((searchpage_module_default()).underline) : "", " ").concat(totalArtworks == 0 ? classnames_default()((searchpage_module_default()).disabled) : ""),
                                    onClick: ()=>{
                                        setShowgalleries(false);
                                        setShowartworks(true);
                                        setShowexhibitions(false);
                                    },
                                    children: [
                                        "Artworks (",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: totalArtworks
                                        }),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "".concat(showgalleries ? classnames_default()((searchpage_module_default()).underline) : "", " ").concat(results.galleries.total == 0 ? classnames_default()((searchpage_module_default()).disabled) : ""),
                                    onClick: ()=>{
                                        setShowgalleries(true);
                                        setShowartworks(false);
                                        setShowexhibitions(false);
                                        setTotalArtworks(results.artworks.total);
                                    },
                                    children: [
                                        "Galleries (",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: results.galleries.total
                                        }),
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "".concat(showexhibitions ? classnames_default()((searchpage_module_default()).underline) : "", " ").concat(results.exhibitions.total == 0 ? classnames_default()((searchpage_module_default()).disabled) : ""),
                                    onClick: ()=>{
                                        setShowgalleries(false);
                                        setShowartworks(false);
                                        setShowexhibitions(true);
                                        setTotalArtworks(results.artworks.total);
                                    },
                                    children: [
                                        "Exhibitions (",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: results.exhibitions.total
                                        }),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    className: (searchpage_module_default()).searchResultsContainer,
                    children: noResults ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (searchpage_module_default()).noResults,
                        children: "No results match your search."
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            showartworks && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPage_ArtworksResults, {
                                catalog: results.artworks,
                                onFilter: setTotalArtworks,
                                filters: filters
                            }),
                            showgalleries && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPage_GalleriesResults, {
                                galleries: results.galleries,
                                searchTerm: searchTerm ? searchTerm.toUpperCase() : " "
                            }),
                            showexhibitions && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPage_ExhibitionsResults, {
                                exhibitions: results.exhibitions,
                                searchTerm: searchTerm ? searchTerm.toUpperCase() : " "
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SearchPage = (Search);

;// CONCATENATED MODULE: ./pages/search/index.js


const search_Search = (param)=>{
    let { results , searchTerm , filters  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPage, {
        results: results,
        searchTerm: searchTerm,
        filters: filters
    });
};
var __N_SSP = true;
/* harmony default export */ var search = (search_Search);


/***/ }),

/***/ 3408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ removeEmptyFromObject; }
/* harmony export */ });
const removeEmptyFromObject = (obj)=>obj && Object.keys(obj).filter((k)=>obj[k] != null).reduce((newObj, k)=>typeof obj[k] === "object" ? {
            ...newObj,
            [k]: removeEmptyFromObject(obj[k])
        } : {
            ...newObj,
            [k]: obj[k]
        }, {});


/***/ }),

/***/ 8351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"circle-image-container":"CircleImages_circle-image-container__3OhLu","circles":"CircleImages_circles__kYojl","gallery-logo":"CircleImages_gallery-logo__7PsMY","gallery-inicials":"CircleImages_gallery-inicials__MpC3t"};

/***/ }),

/***/ 6390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"exhibitions":"ExhibitionsBig_exhibitions__PvK7b","exhibitionInfo":"ExhibitionsBig_exhibitionInfo__794_u","bottom":"ExhibitionsBig_bottom__ZUYyN"};

/***/ }),

/***/ 4038:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"underline":"searchpage_underline__H_drC","searchHeader":"searchpage_searchHeader__QsVOh","disabled":"searchpage_disabled__G_GnF","noResults":"searchpage_noResults__kyr0H","searchBar":"searchpage_searchBar__rPAWl","searchResults":"searchpage_searchResults__D55ie","searchResultsContainer":"searchpage_searchResultsContainer__SY4zT"};

/***/ }),

/***/ 1772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonCta_button__11mLL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,144,686,233,317,604,461,774,888,179], function() { return __webpack_exec__(7646); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);